<button
    class="button cancel-button"
    [disabled]="disabled"
    (click)="cancel.emit()">
    <mat-icon>block</mat-icon>
    {{ 'Common.Cancel' | translate }}
</button>